'use client';

import { getImageProps } from 'next/image';

import { getImageLink } from '@/services/link.service';
import { directusImageLoader } from '@/utils/loaders';

import Styles from './WarrantySection.module.scss';

type Props = {
  warranty_image: string | undefined;
};

const WarrantyImage = ({ warranty_image }: Props) => {
  const imageKeys = {
    desktopKey: 'image-192-244',
    mobileKey: 'image-124-158',
  };
  const common = {
    alt: 'Hero',
    width: 192,
    height: 244,
    loader: directusImageLoader,
  };
  const image = getImageLink(warranty_image);
  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    src: image ? `${image}?key=${imageKeys.mobileKey}` : '',
  });

  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: image ? `${image}?key=${imageKeys.desktopKey}` : '',
  });

  return (
    <picture className={Styles.warrantyImg}>
      <source media="(max-width: 575px)" srcSet={mobile} />
      <source media="(min-width: 576px)" srcSet={desktop} />
      <img {...rest} alt="hero-banner-image" />
    </picture>
  );
};

export default WarrantyImage;
